let vimeoVideosArray = [];

function loadVimeoApi() {
    const tag = document.createElement('script');
    //tag.src = `${window.location.protocol}//player.vimeo.com/api/player.js`;
    tag.src = 'https://player.vimeo.com/api/player.js';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    tag.onload = setupVideos;
}

function setupVideos() {
    Array.from(vimeoVideosArray).forEach(vimeoVideo => {
        const iframe = vimeoVideo.querySelector('iframe');

        if (iframe) {
            const player = new Vimeo.Player(iframe);

            player.on('bufferstart', function() {
                if (!vimeoVideo.classList.contains('video--loading')) {
                    vimeoVideo.classList.add('video--loading');
                }
            });

            player.on('play', function() {
                vimeoVideo.classList.remove('video--loading');
                vimeoVideo.classList.add('video--playing');
            });

            player.on('ended', function() {
                vimeoVideo.classList.remove('video--playing');
            });

            const playTrigger = vimeoVideo.hasAttribute('data-video-play-trigger') ? document.getElementById(vimeoVideo.getAttribute('data-video-play-trigger')) : null;

            if (playTrigger) {
                playTrigger.addEventListener('click', () => {
                    vimeoVideo.classList.add('video--loading');
                    player.play();
                });
            }
        }
    });
}

export function setupVimeoVideos(selector = '[data-action="vimeo-video"]') {
    const vimeoVideos = document.querySelectorAll(selector);

    if (vimeoVideos.length > 0) {
        vimeoVideosArray = vimeoVideos;
    }

    loadVimeoApi();
}
